import { computed, defineComponent, onMounted, onUnmounted, onUpdated, ref } from 'vue';
import { useStore } from 'vuex';
import { ProvinceAction, ProvinceGetter } from '@/store/province/province.module';
import { Province } from '@/store/province/province.model';
import LoadingComponent from '@/components/loading/Loading.vue';

export default defineComponent({
  name: 'ProvinceTableComponent',
  components: {
    LoadingComponent
  },
  emits: [
    'edit'
  ],
  setup: (_, context) => {
    const store = useStore();
    const provinces = computed<Province[]>(() => store.getters[ProvinceGetter.ALL]);
    const isLoading = computed(() => store.getters[ProvinceGetter.STATUS] === 'init' || store.getters[ProvinceGetter.STATUS] === 'loading');
    const datatable = ref<HTMLTableElement>();
    const dtInstance = ref();

    onMounted(() => {
      store.dispatch(ProvinceAction.FETCH)
        .then(() => initialDataTable());
    });

    onUpdated(() => initialDataTable());

    onUnmounted(() => {
      dtInstance.value?.destroy();
    });

    const initialDataTable = () => {
      Promise.resolve(dtInstance.value?.destroy())
        .then(() => {
          const dt = datatable.value as HTMLTableElement;
          if (!$.fn.dataTable.isDataTable(dt)) {
            dtInstance.value = $(dt).DataTable({
              language: {
                emptyTable: 'ไม่พบข้อมูล',
                info: 'แสดง _START_ ถึง _END_ จากจำนวนทั้งหมด _TOTAL_',
                infoEmpty: 'แสดง 0 ถึง 0 จากจำนวนทั้งหมด 0',
                infoFiltered: '(ค้นหาจากจำนวนทั้งหมด _MAX_)',
                lengthMenu: 'แสดงข้อมูล _MENU_',
                paginate: {
                  next: 'ถัดไป',
                  previous: 'ก่อนหน้า',
                  first: 'First',
                  last: 'Last'
                },
                search: 'ค้นหา:',
                zeroRecords: 'ไม่พบข้อมูลที่ค้นหา',
              }
            });
          }
        });
    };

    const editClick = (id: number) => {
      context.emit('edit', id);
    };

    return {
      isLoading,
      provinces,
      datatable,
      editClick
    };
  },
});
